module.exports = __webpack_public_path__ + "img/folded_hands.f6ea31a0.png";